import { d as calculateLineHeight } from './breakpointCustomizable-ff31979d.js';
var calcLineHeightForElement = function (tag) {
    var fontSize = window.getComputedStyle(tag).fontSize;
    // fontSize is "" when element does no longer exist and would throw an exception in calculateLineHeight
    return fontSize && calculateLineHeight(fontSize);
};
export { calcLineHeightForElement as c };
